var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 42c11.046 0 20-8.954 20-20S33.046 2 22 2 2 10.954 2 22s8.954 20 20 20zm-10.176-9.818h4.29V18.375h-4.29v13.807zm-.4-18.283a2.502 2.502 0 105.003 0 2.502 2.502 0 00-5.003 0zM27.9 32.183h4.288v-7.573c0-3.718-.803-6.577-5.148-6.577-2.087 0-3.487 1.145-4.06 2.23h-.058v-1.887h-4.116v13.807h4.288v-6.83c0-1.802.343-3.546 2.576-3.546 2.2 0 2.23 2.06 2.23 3.662v6.714z",
    fill: "#000",
    className: "hover"
  })));
}
export default SvgLinkedinIconDark;